import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getProductFormattedNumber } from '../../../helpers/CurrencyUtils';
import { getProductAwardAmount, getProductDisplayName } from '../../../helpers/ProductUtils';

export default function ItemConvertSubmission({ selectedPackage, handleSubmit, handleClose }) {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm fade-in show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade in" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sm">
          <div className="modal-header">
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid */}
            <a
              className="close phoenix-icon phoenix-icon-cross hidden-xs hidden-sm"
              aria-hidden="true"
              onClick={handleClose}
            />
            <h4>{t('item_convert_are_you_sure_')}</h4>
          </div>
          <div className="modal-body">
            <p id="item-convert-confirmation-text">
              {
                t(
                  'item_convert_this_will_remove___diamonds___diamonds_from_your_account_and_add___item__',
                  {
                    diamonds: getProductFormattedNumber(selectedPackage.purchase.price),
                    amount: getProductFormattedNumber(getProductAwardAmount(selectedPackage)),
                    item: getProductDisplayName(selectedPackage),
                  },
                )
              }
            </p>
          </div>
          <div className="modal-footer">
            <form className="form-horizontal">
              <div className="form-group">
                <div className="col-xs-12">
                  <button
                    type="button"
                    className="btn btn-undesired btn-half"
                    data-dismiss="modal"
                    onClick={handleClose}
                    aria-hidden="true"
                  >
                    {t('item_convert_cancel')}
                  </button>
                  <button
                    id="submit-item-convert"
                    type="submit"
                    onClick={handleSubmit}
                    className="btn btn-primary btn-half"
                    aria-hidden="true"
                  >
                    {t('item_convert_ok')}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
ItemConvertSubmission.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  selectedPackage: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
